import PortfolioPage from './components/card/cards';
import './style.css';

function App() {
  return (
    <div className="App">
      <PortfolioPage />
    </div>
  );
}

export default App;
